import { BUTTON_LAYOUTS, PAGE_LOCATIONS } from '@/types/store';
import { PRODUCT_TYPES } from '@/lib/constants';
import { ProductPage, ServerPageData } from '../types';

// TODO: PAVI - Verify if we still need this
export const defaultPageData: ProductPage = {
    metadata: {
        pageId: undefined,
        location: PAGE_LOCATIONS.STORE,
        order: 999,
        status: 0,
    },
    storePresentation: {
        title: 'Get My Guide',
        text: 'Button',
        image: '',
        layout: BUTTON_LAYOUTS.CALLOUT,
        tagline: 'We will deliver this file right to your inbox',
        bottomTitle: 'Get My Guide',
        submitTitle: 'PURCHASE',
        topBannerText: 'Get My Guide',
    },
    productPresentation: {
        description: 'Get My Guide',
        image: '',
    },
    product: {
        id: -1,
        type: PRODUCT_TYPES.DIGITAL_DOWNLOAD,
    },
    options: {
        reviews: [],
        emailFlows: [],
        secondBuiltInProduct: {
            enabled: false,
            pageId: -1,
            discountPercentage: 0,
        },
        resellRights: {
            enabled: false,
            percentage: 0,
            affiliateTermsAndCondition: {
                enabled: false,
                text: '',
            },
        },
        communityIntegration: {
            enabled: false,
        },
        emails: [],
        currencyOverride: undefined,
        slug: null,
    },
};

export const DEFAULT_PRODUCT_DATA: Partial<Record<keyof typeof PRODUCT_TYPES, ServerPageData>> = {
    [PRODUCT_TYPES.DIGITAL_DOWNLOAD as keyof typeof PRODUCT_TYPES]: {
        location: '',
        button: {
            layout: BUTTON_LAYOUTS.CALLOUT,
            tagline: 'We will deliver this file right to your inbox',
            button_text: 'Get My Guide',
            image: '',
        },
        product: {
            id: 0,
            type: PRODUCT_TYPES.DIGITAL_DOWNLOAD,
            title: 'Get My [Template/eBook/Course] Now!',
            description: `<p>This [Template/eBook/Course] will teach you everything you need to achieve your goals.</p><p><b>This guide is for you if you're looking to:</b></p><ul><li><p>Achieve your Dream</p></li><li><p>Find Meaning in Your Work</p></li><li><p>Be Happy</p></li></ul>`,
            image: '',
            emails: {},
            reviews: [],
            questions: [],
            price: {
                amount: 0,
                currency: 'USD',
                sale_amount: 0,
                sale_amount_available: false,
                discount_codes_available: false,
            },
            inventory: {
                stock: 0,
                manage: false,
                low_stock_amount: 0,
            },
        },
        second_built_in_product: {
            enabled: false,
            page_id: -1,
        },
        affiliate_shares: [],
        resell_rights: {
            enabled: false,
            percentage: 0,
            affiliate_terms_and_condition: {
                enabled: false,
                text: '',
            },
        },
        community_integration: {
            enabled: false,
        },
        countdown_timer: {},
    },
};
